var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTabletteSmart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-tablette-smart",
    transform: "translate(-2423 -10298)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 40,
    height: 40,
    transform: "translate(2423 10298)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_tablette-smart",
    transform: "translate(2420.5 10295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_61",
    "data-name": "Trac\\xE9 61",
    d: "M37.75,13.09H30V8a3,3,0,0,0-3-3H8A3,3,0,0,0,5,8V37a3,3,0,0,0,3,3H27a.847.847,0,0,0,.115-.005A1.218,1.218,0,0,0,27.25,40h10.5A2.253,2.253,0,0,0,40,37.75V15.34A2.253,2.253,0,0,0,37.75,13.09Zm-8.47,1.5h6.44v1.13a.749.749,0,0,1-.75.75H30.03a.088.088,0,0,1-.03-.005.742.742,0,0,1-.72-.745V14.59ZM6.5,8A1.5,1.5,0,0,1,8,6.5H27A1.5,1.5,0,0,1,28.5,8V9H6.5ZM8,38.5A1.5,1.5,0,0,1,6.5,37v-.5H25v1.25a2.189,2.189,0,0,0,.13.75ZM25,15.34V35H6.5V10.5h22v2.59H27.25A2.253,2.253,0,0,0,25,15.34ZM38.5,37.75a.749.749,0,0,1-.75.75H27.25a.292.292,0,0,1-.095-.01h0a.741.741,0,0,1-.65-.74V15.34a.749.749,0,0,1,.75-.75h.53v1.13A2.259,2.259,0,0,0,30,17.97h4.97a2.253,2.253,0,0,0,2.25-2.25V14.59h.53a.749.749,0,0,1,.75.75Z",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_62",
    "data-name": "Trac\\xE9 62",
    d: "M60,66.78a.749.749,0,0,1-.75.75H53.21a.75.75,0,1,1,0-1.5h6.04A.749.749,0,0,1,60,66.78Z",
    transform: "translate(-23.73 -30.515)",
    fill: "#646464"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTabletteSmart);
export default __webpack_public_path__ + "static/media/ico-tablette-smart.d7650b2751f8671ccab0686dbd438910.svg";
export { ForwardRef as ReactComponent };